import React from 'react';
import { Snackbar } from '@mui/material';

export default function InfoMessage({ info, close }) {
  return (
    <Snackbar
      open
      onClose={close}
      message={info}
      autoHideDuration={3000}
      severity="info"
    />
  );
}
